module.exports = __webpack_public_path__ + "static/media/pmg_white_logo.b86792bc.svg";